import validate from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_eslint@8.57.1_ioredis@5.6.1_m_p4d5hasxlumsou4wvpjboxtdmu/node_modules/nuxt/dist/pages/runtime/validate.js";
import setup_45global from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/middleware/setup.global.ts";
import transition_45global from "/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/apps/nuxt/middleware/transition.global.ts";
export const globalMiddleware = [
  validate,
  setup_45global,
  transition_45global
]
export const namedMiddleware = {}